.fp-staff-layout
  .fp-staff-layout--modal
    .fp-modal
      ForgotCodeVue(v-if='forgotCodeStep' @email-filled='e => askResetPassword(e.value)')
      ResetPasswordVue(v-else :email='email')
